import React from 'react';
import { PrepareSmsCampaign } from './prepare-sms-campaign';


export const SmsCampaignComponent = ({
  choosenCampaign,
  campaignFrequency,
  id,
  chosenSmsCampaign,
  selectedTemplate,
  setSelectedTemplate,
  choosenTemplate,
  handleInnerFormChange,
  rowData,
  columnDefs,
  setPageData,
  customerTags,
  paginationData,
  vendorRowData,
  VendorpaginationData,
  vendorColumnDefs,
  agents
}: any) => {
  
  return (
    <>
      <PrepareSmsCampaign
        choosenCampaign={choosenCampaign}
        handleInnerFormChange={handleInnerFormChange} 
        campaignFrequency={campaignFrequency}
        customerTags={customerTags}
        choosenEmailPlan={chosenSmsCampaign}   
        setSelectedTemplate={setSelectedTemplate}
        selectedTemplate={selectedTemplate}   
        choosenTemplate={choosenTemplate}
        id={id}
        rowData={rowData}
        columnDefs={columnDefs}
        setPageData={setPageData}
        paginationData={paginationData}
        vendorRowData={vendorRowData}
        VendorpaginationData={VendorpaginationData}
        vendorColumnDefs={vendorColumnDefs}
        agents={agents}
       />

     
    </>
  );
};
export default SmsCampaignComponent;
